export enum apiMethodTypes {
  get = 'GET',
  post = 'POST'
}


// WEBPACK FOOTER //
// ./src/constants/apiMethodTypes.ts